// extracted by mini-css-extract-plugin
export default {"section":"section_section__2pdRE","heading":"section_heading__T9Gr+","extra":"section_extra__OkDdM"};